/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FooterSubscribe_viewer$ref = any;
type SocialLinkRow_viewer$ref = any;
export type LinkColumn_viewer$ref = any;
export type LinkColumn_viewer = {
    readonly " $fragmentRefs": SocialLinkRow_viewer$ref & FooterSubscribe_viewer$ref;
    readonly " $refType": LinkColumn_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "LinkColumn_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SocialLinkRow_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterSubscribe_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '5d3d19d4b92bc2a4a497ea5c33c6fbec';
export default node;
